export default {
    info: {
        is_official_open: '是否正式开放网站',
        open: '开启',
        close: '关闭',
        please_select_open_status: '请选择是否开放网站',
        footer_content: '网站底部内容',
        please_enter_footer_content: '请输入网站底部内容',
        save: '保存'
    },
    style: {
        template_select: '模板选择',
        background_color: '背景色',
        background_color_required: '背景色顏色不能为空',
        theme_color: '主题色',
        theme_color_required: '主题色顏色不能为空',
        nav_color_select: '导航颜色选择',
        nav_home: '首页',
        nav_basic_info: '基本信息',
        nav_organization: '组织机构',
        nav_submission: '征文投稿',
        nav_schedule: '学术日程',
        nav_registration: '参会注册',
        nav_hotel: '酒店交通',
        nav_contact: '联系我们',
        nav_bg_color: '导航背景颜色选择',
        nav_selected_color: '导航选中颜色选择',
        nav_selected_font_color: '导航选中字体颜色选择',
        nav_font_color: '导航字体颜色选择',
        save: '保存'
    },
    page_content: {
        content_status_show: '显示',
        content_status_hide: '隐藏',
        edit_content: '编辑',
        manage_content: '管理内容',
        nav_name: '导航名称',
        nav_type: '栏目类型',
        content_hidden: '是否隐藏',
        content_operation: '操作',
        type_not_supported: '暂不支持此类型',
        nav_edit: '栏目编辑',
        nav_id: '栏目id'
    },
    nav_list: {
        add_nav: '新增',
        nav_status_show: '显示',
        nav_status_hide: '隐藏',
        add_sub_nav: '增加子栏目',
        edit_nav: '编辑',
        manage_content: '管理内容',
        delete_nav: '删除',
        nav_sort: '排序',
        nav_menu: '导航菜单',
        nav_type: '栏目类型',
        nav_hidden: '是否隐藏',
        nav_operation: '操作',
        confirm_delete: '您确定要删除【',
        confirm_delete_end: '】?',
        new_nav: '新增栏目',
        registration_notice: '参会须知',
        module_name: '栏目名称',
        please_enter_module_name: '请输入栏目名称',
        module_type: '栏目类型',
        please_select_module_type: '请选择栏目类型',
        subtitle: '副标题',
        is_show: '是否显示',
        yes: '是',
        no: '否',
        select_time: '选择时间',
        please_select_time: '请选择时间',
        content: '内容',
        please_enter_content: '请输入内容',
        jump_link: '跳转链接',
        is_anonymous_message: '是否匿名留言',
        please_select_is_anonymous_message: '请选择是否匿名留言',
        open_new_page: '是否在新页面打开',
        please_select_open_new_page: '请选择是否在新页面打开',
        sort: '排序',
        please_enter_sort: '请输入排序',
        display_count: '显示条数',
        sort_tip: '默认为 10',
        submit: '立即提交',
        module_edit: '栏目编辑',
        please_select_is_show: '请选择是否显示'
    },
    button_list: {
        add_button: '新增快捷通道',
        edit: '编辑',
        delete: '删除',
        confirm_delete: '确定要删除吗？',
        title: '标题',
        subtitle: '副标题',
        link: '链接',
        sort: '排序',
        open_new_page: '是否在新页面打开',
        operation: '操作',
        yes: '是',
        no: '否',
        icon: '图标',
        url:'跳转地址',
        create_time:'创建时间',
        display:'是否显示'
    },
    button_info: {
        title_type: '标题类型',
        title: '标题',
        subtitle: '副标题',
        link: '链接',
        link_tip: '请输入带有 http:// 或 https:// 的链接',
        sort: '排序',
        open_new_page: '是否在新页面打开',
        please_select_open_new_page: '请选择是否在新页面打开',
        submit: '立即提交',
        clear: '清除'
    },
    image_info: {
        title: '标题',
        please_enter_title: '请输入标题',
        subtitle: '副标题',
        upload_image: '上传图片',
        image_tip: '支持JPG,GIF,PNG图片文件，文件大小不能超过2M',
        link: '链接',
        link_tip: '请输入带有 http:// 或 https:// 的链接',
        sort: '排序',
        open_new_page: '是否在新页面打开',
        please_select_open_new_page: '请选择是否在新页面打开',
        submit: '立即提交',
        only_image_files: '您只能上传图像文件',
        upload_image_mobile: '手机端图片'
    },
    image_list: {
        add_image: '新增图片',
        copyright_notice: '为避免图片版权纠纷，可上传上届会议图片，务必避免上传没有授权的网上风景或城市照片',
        edit: '编辑',
        delete: '删除',
        sort: '排序',
        title: '标题',
        image: '图片',
        create_time: '创建时间',
        operation: '操作',
        image_list: '图片列表',
        confirm_delete_item: '您确定要删除【{title}】?',
        yes: '是',
        no: '否'
    },
    news_info: {
        add: '新增',
        title: '标题',
        please_enter_title: '请输入标题',
        source: '来源',
        description: '描述',
        title_style: '标题样式',
        bold: '加粗',
        highlight: '高亮',
        new_icon: 'new图标',
        hot_icon: 'hot图标',
        upload_image: '上传图片',
        image_tip: '支持JPG,GIF,PNG图片文件，文件大小不能超过2M',
        clear: '清除',
        sort: '排序',
        external_link: '外部链接',
        link_tip: '请输入带有 http:// 或 https:// 的链接',
        content: '内容',
        please_enter_content: '请输入内容',
        submit: '立即提交',
        only_image_files: '您只能上传图像文件'
    },
    news_list: {
        add_news: '新增新闻',
        show: '显示',
        hide: '隐藏',
        edit: '编辑',
        delete: '删除',
        sort: '排序',
        title: '标题',
        creator: '创建人',
        show_hide: '显示|隐藏',
        create_time: '创建时间',
        operation: '操作',
        news_list: '新闻列表',
        confirm_delete_item: '您确定要删除【{title}】?'
    },
    guest_info: {
        add: '新增',
        name: '姓名',
        please_enter_name: '请输入姓名',
        photo: '照片',
        photo_tip: '150*150px，支持JPG,GIF,PNG图片文件，大于500K会被自动压缩',
        upload_photo: '上传照片',
        clear: '清除',
        company: '单位',
        title: '职称',
        position: '职务',
        sort: '排序',
        external_link: '外部链接',
        link_tip: '请输入带有 http:// 或 https:// 的链接',
        introduction: '简介',
        please_enter_content: '请输入内容',
        submit: '立即提交',
        only_image_files: '您只能上传图像文件'
    },
    guest_list: {
        add_guest: '新增特邀讲者',
        edit: '编辑',
        delete: '删除',
        sort: '排序',
        name: '姓名',
        title: '职称',
        position: '职务',
        creator: '创建人',
        create_time: '创建时间',
        operation: '操作',
        guest_list: '特邀讲者',
        confirm_delete_item: '您确定要删除【{name}】?'
    },
    formConfig: {
        only_upload_image: '您只能上传图像文件',
        upload_error: '上传失败'
    },
    loading: 'Loading...'
};
